// extracted by mini-css-extract-plugin
export default {"content":"unsaved-changes-modal_content__N88fc","message":"unsaved-changes-modal_message__Mex5F","actions":"unsaved-changes-modal_actions__yZ8+2"};